const Error = () => {
    return (
        <div>
            Error 404 
            NOT FOUND
        </div>
    );
};

export default Error;